import Axios from "axios";
import { takeLatest, put, call } from 'redux-saga/effects';
import { AUTH_SERVER } from '../../config'
import {
    LOGIN,
    loginSuccess,
    loginFailure
} from './action';

export function* rubixLogin(action) {
    let requestURL = `${AUTH_SERVER}/auth/login`;
    try {
        const result = yield call(Axios.post, requestURL, action.data);
        yield put(loginSuccess(result.data));
    } catch (err) {
        yield put(loginFailure(err))
    }
}
export function* login() {
    yield takeLatest(LOGIN, rubixLogin);
}